/**
 * Millisecond formatting for the telemetry dashboard.
 *
 * `hours()` in ../../lib/format.js starts at minutes — too coarse for a p95
 * that lives in the hundreds of milliseconds, which is the range that
 * actually distinguishes "fine" from "the thing everyone is complaining
 * about" on this screen.
 */
export function formatMs(v: number): string {
  if (v < 1000) return `${Math.round(v)}ms`;
  return `${(v / 1000).toFixed(v < 10_000 ? 1 : 0)}s`;
}
